import {cn} from "../../../../../../lib/utils.ts";
import {fieldVariants} from "../../../../../../components/general/fieldStyles.ts";
import {InformationCircleIcon, ArrowUpIcon} from "@heroicons/react/24/outline";

type AiPromptCardProps = {
    value: string
    onChange: (value: string) => void
    onSubmit: () => void
    isGenerating: boolean
    disabled?: boolean
}

export function AiPromptCard({value, onChange, onSubmit, isGenerating, disabled = false}: AiPromptCardProps) {
    const canSubmit = !isGenerating && !disabled && value.trim().length > 0

    return (
        <div className="bg-gray-50 border border-gray-200 rounded-lg p-5">
            <div className="relative flex items-center">
                <input
                    type="text"
                    className={cn(fieldVariants(), "pr-12")}
                    placeholder="Bijvoorbeeld: 'Factuur voor Acme Corp, 1000 euro voor webdesign diensten, betaaltermijn 30 dagen'"
                    disabled={disabled}
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            e.preventDefault()
                            if (canSubmit) onSubmit()
                        }
                    }}
                />
                <button
                    type="button"
                    onClick={onSubmit}
                    disabled={!canSubmit}
                    aria-label="Genereer factuur uit tekst"
                    className="absolute right-2 bg-primary text-white w-6 h-6 rounded-full flex items-center justify-center shadow-md hover:opacity-90 hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:opacity-50 disabled:hover:shadow-md transition-all duration-200"
                >
                    {isGenerating ? (
                        <svg className="animate-spin h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                    ) : (
                        <ArrowUpIcon className="w-4 h-4" strokeWidth={2}/>
                    )}
                </button>
            </div>
            <p className="mt-2 flex items-center gap-1.5 text-xs text-gray-500">
                <InformationCircleIcon className="h-4 w-4 flex-shrink-0"/>
                Typ wat je wilt factureren — klant, regels, btw en betaaltermijn worden automatisch ingevuld.
            </p>
        </div>
    )
}
